import React from 'react';
import { LayersIcon, TargetIcon, TrendingUpIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { GlassCard } from '../ui/GlassCard';
import { CognitiveDashboard } from '../ui/CognitiveDashboard';
export function HeroSection() {
  return <SectionWrapper className="min-h-screen flex items-center pt-32 pb-24" glowPosition="left" data-id="element-89">
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-90" />

      <div className="grid lg:grid-cols-2 gap-16 items-center relative z-10" data-id="element-91">
        {/* Left Content */}
        <div className="flex flex-col gap-8" data-id="element-92">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-500/10 border border-cyan-500/20 w-fit" data-id="element-93">
            <div className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse" data-id="element-94" />
            <span className="text-xs font-mono text-cyan-300 uppercase tracking-widest" data-id="element-95">
              System Initialization
            </span>
          </div>

          <div data-id="element-96">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold tracking-tighter text-white mb-6 leading-[1.1]" data-id="element-97">
              Cognarchic <br data-id="element-98" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-400 text-glow-cyan" data-id="element-99">
                State
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-slate-300 max-w-2xl leading-relaxed mb-6 font-light" data-id="element-100">
              A cognitive-based governance model where civic influence,
              institutional access, and leadership eligibility are continuously
              aligned with demonstrated judgment, reasoning quality, and
              resilience under pressure.
            </p>

            <p className="text-base text-slate-400 max-w-2xl leading-relaxed" data-id="element-101">
              Modern civilization is increasingly destabilized by poor judgment,
              emotional volatility, propaganda, and institutional decay. The
              Cognarchic State presents itself as a response to this crisis by
              treating sound judgment as a core public good to be cultivated,
              measured, and protected.
            </p>
          </div>

          <div className="grid sm:grid-cols-3 gap-4 mt-4" data-id="element-102">
            <GlassCard className="p-5" glowColor="cyan" data-id="element-103">
              <LayersIcon className="w-6 h-6 text-cyan-400 mb-3" data-id="element-104" />
              <div className="text-xs text-slate-400 uppercase tracking-wider mb-1" data-id="element-105">
                Core Framework
              </div>
              <div className="text-sm font-medium text-white" data-id="element-106">
                Neurocognitive Civic Judgment Index (NCJI)
              </div>
            </GlassCard>

            <GlassCard className="p-5" glowColor="teal" data-id="element-107">
              <TargetIcon className="w-6 h-6 text-teal-400 mb-3" data-id="element-108" />
              <div className="text-xs text-slate-400 uppercase tracking-wider mb-1" data-id="element-109">
                Core Thesis
              </div>
              <div className="text-sm font-medium text-white" data-id="element-110">
                Leadership is earned through demonstrated competence
              </div>
            </GlassCard>

            <GlassCard className="p-5" glowColor="blue" data-id="element-111">
              <TrendingUpIcon className="w-6 h-6 text-blue-400 mb-3" data-id="element-112" />
              <div className="text-xs text-slate-400 uppercase tracking-wider mb-1" data-id="element-113">
                Central Aim
              </div>
              <div className="text-sm font-medium text-white" data-id="element-114">
                Raise the quality of mind across the population
              </div>
            </GlassCard>
          </div>
        </div>

        {/* Right Content - Dashboard Visual */}
        <div className="hidden lg:block" data-id="element-115">
          <CognitiveDashboard data-id="element-116" />
        </div>
      </div>
    </SectionWrapper>;
}